import { component } from 'picoapp'
import Splide from '@splidejs/splide'

export default component(async (node) => {
  const sliderElement = node.querySelector('.splide')
  const sliderControls = sliderElement.querySelector('[data-slider-controls]')

  if (!sliderElement) return

  const paginationAttr = sliderElement.getAttribute('data-pagination')
  const paginationSetting = paginationAttr === 'false' ? false : true

  const slider = new Splide(sliderElement, {
    arrows: true,
    pagination: paginationSetting,
    perPage: 1,
    drag: true,
    gap: 12,
    mediaQuery: 'min',
    breakpoints: {
      1024: {
        destroy: true,
      },
    },
  })

  const toggleSliderControls = () => {
    const slides = slider.Components.Slides.getLength()
    if (slides < 2) {
      sliderControls.classList.add('tw-hidden')
    } else {
      sliderControls.classList.remove('tw-hidden')
    }
  }

  slider.on('updated', () => {
    toggleSliderControls(slider)
  })
  slider.on('mounted', () => {
    toggleSliderControls(slider)
  })
  slider.mount()
})
